var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type == "refund" ? "Refund" : "Please note",
        visible: _vm.isOpen,
        width: "7rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        [
          _vm.type == "notReceived"
            ? _c("div", { staticClass: "notReceived flexStart" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "After confirming that the test token has not been received, the user account will fail to bind!"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "refund"
            ? _c(
                "el-form",
                {
                  ref: "assetForm",
                  staticClass: "page-form point-form",
                  attrs: { model: _vm.pageData, "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "Account",
                                label: "treasurenet Account",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$store.getters.metaMaskObj.account
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "amount",
                                label: "Refund ETH/BTC",
                              },
                            },
                            [
                              _c("span", { staticClass: "num" }, [
                                _vm._v(_vm._s(_vm.minAmount)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer page-btns",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            attrs: { type: "primary", label: _vm.submitText },
            on: { clickHandle: _vm.approval },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }